import { createAction, Action } from 'redux-actions';
import { ReferralType } from '@wix/da-bi/pkg/constants';
import { LoggedOutReturnType } from './types';

export type RestrictLoggedOutPayload = {
  restrictedActionName: ReferralType;
  returnTo?: string;
  returnType?: LoggedOutReturnType;
};

export const restrictLoggedOut = createAction(
  '@@loggedOut/RESTRICT_ACCESS',
  (payload: RestrictLoggedOutPayload) => payload
);

// this is an easy way to wrap existing actions to check for logged out
// but do remember that any reducers/sagas need to handle the _wrapped_ action
// so you must have access to the original action type
// the whole type/function jugglery here is to ensure proper typings in the result
export const VERIFY_ACCESS = '@@loggedOut/VERIFY_ACCESS';
export const verifyLoggedOutAccess =
  <TActionCreator extends (...args: any) => Action<any>>(
    restrictedActionName: ReferralType,
    actionCreator: TActionCreator
  ) =>
  (...args: Parameters<TActionCreator>) => ({
    type: VERIFY_ACCESS,
    payload: {
      action: actionCreator(...(args as Iterable<any>)),
      restrictedActionName,
    },
  });
